module.exports = __webpack_public_path__ + "img/portfolio-big-10.4351507e.png";